import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { UserService } from './user.service';
import { UserListItem, UserSearchParam } from '../../interfaces/user/user-type.interface';
import { environment } from '../../../../../environments/environment.dev';
import { convertToHttpParams } from '../../../../core/interfaces/common-search-param.interface';
import { PageResponse } from '../../../../core/interfaces/page-response.interface';

@Injectable({
    providedIn: 'root'
})
export class UserApiService extends UserService {
    private http = inject(HttpClient);
    private readonly baseUrl = `${environment.apiBaseUrl}v1/users`;

    constructor() {
        super();
    }

    override findAll(searchParam: UserSearchParam): Observable<PageResponse<UserListItem>> {
        return this.wrapRequest(
            this.http.get<PageResponse<UserListItem>>(this.baseUrl, {
                headers: this.headers,
                params: convertToHttpParams(searchParam)
            }).pipe(
                map((response: any) => response.response || response)
            )
        );
    }

    override find(id: string): Observable<UserListItem> {
        return this.wrapRequest(
            this.http.get<UserListItem>(`${this.baseUrl}/${id}`, { headers: this.headers })
        );
    }

    override create(data: any): Observable<any> {
        return this.wrapRequest(
            this.http.post<any>(`${this.baseUrl}/register`, data, { headers: this.headers })
        );
    }

    override update(id: string, data: any): Observable<any> {
        return this.wrapRequest(
            this.http.put<any>(`${this.baseUrl}/${id}`, data, { headers: this.headers })
        );
    }

    override delete(id: string): Observable<void> {
        return this.wrapRequest(
            this.http.delete<void>(`${this.baseUrl}/${id}`, { headers: this.headers })
        );
    }
    
    override updateStatus(id: string, status: boolean): Observable<void> {
        return this.wrapRequest(
            this.http.put<void>(`${this.baseUrl}/${id}/status`, null, {
                headers: this.headers,
                params: { status: status.toString() }
            })
        );
    }

    override updatePassword(uniqueId: string, password: string): Observable<void> {
        const payload = { adminUniqueId: uniqueId, password };
        return this.wrapRequest(
            this.http.put<void>(`${this.baseUrl}/password`, payload, { headers: this.headers })
        );
    }
}
